import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss']
})
export class ConfirmationModalComponent implements OnInit {
  assetsUrl = '';
  constructor() { 
    //do nothing
  }

  ngOnInit(): void {
    this.assetsUrl = environment.assetsUrl;
  }

}
